import { UseFormSetValue } from "react-hook-form";

import { AddPracticeFormProps } from "src/pages/addPractice/types";
import { NPIPracticeType } from "src/types";



export const populateAddPracticeForm = (setValue: UseFormSetValue<AddPracticeFormProps>, practiceData: NPIPracticeType, npi: string) => {
  if (practiceData) {
    setValue("name", practiceData.basic.practice_name || "");
    setValue("address.street", practiceData.address_data.street || practiceData.address_data.address_1);
    setValue("address.suite", practiceData.address_data.address_2 || "");
    setValue("address.city", practiceData.address_data.city);
    setValue("address.zip", practiceData.address_data.postal_code);
    setValue("address.state", practiceData.address_data.state);
    setValue(
      "phone_number",
      practiceData.address_data.telephone_number ? practiceData.address_data.telephone_number.toString().replace(/-/g, "") : ""
    );
    setValue(
      "fax_number",
      practiceData.address_data.fax_number ? practiceData.address_data.fax_number.toString().replace(/-/g, "") : ""
    );
  }
}
